import React, { useContext } from 'react'
import { Route, Routes } from 'react-router-dom'

import NotFound from '../NotFound'

import { AbilityContext } from '../../components/Ability'
import ProductsListPage from './Features/ProductsList'

const ProductsPage = () => {
  const ability = useContext(AbilityContext)

  return (
    <Routes>
      <Route
        path="/"
        element={
          ability.can('manage', 'Product', 'productList') ? <ProductsListPage /> : <NotFound />
        }
      />
    </Routes>
  )
}

export default ProductsPage
